<template>
  <div>
    Video
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>